import { useEffect, useState } from "react";
import Duration from "../Archive/Duration";

const MetaCircle = (props) => {
  const { mixes, activeIndex } = props;

  return (
    <div
      className={`home__meta-circle-wrapper ${
        mixes[activeIndex]._type === "editorsLetter" ? "opacity" : ""
      }`}
    >
      <svg viewBox="0 0 100 100" className="home__meta-circle-text">
        <defs>
          <path
            id="circlePath"
            d="M50,50 m-40,0 a40,40 0 1,1 80,0 a40,40 0 1,1 -80,0"
          />
        </defs>
        <text>
          {mixes[activeIndex]._type === "editorsLetter" ? (
            <textPath href="#circlePath" startOffset="50%" textAnchor="middle">
              RA
              MIX&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LONDON
            </textPath>
          ) : (
            <textPath href="#circlePath" startOffset="50%" textAnchor="middle">
              RA
              MIX&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {mixes[activeIndex].location}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;GENRE:
              {mixes[activeIndex].genre}
              &nbsp;&nbsp;&nbsp;&nbsp;DURATION:{mixes[activeIndex].duration}
            </textPath>
          )}
        </text>
      </svg>
      <div className={`home__meta-number ${
        mixes[activeIndex]._type === "editorsLetter" ? "opacity" : ""
      }`}>
        {mixes[activeIndex]._type === "editorsLetter"
          ? "1000"
          : mixes[activeIndex].mixNumber}
      </div>
    </div>
  );
};

export default MetaCircle;
